import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card001ResilienceFrame() {
  return <KbCardPage slug="card-001-resilience-frame" />;
}

(Card001ResilienceFrame as unknown as { path: string }).path = "/methodology/001";
